import React from "react";

export interface AppConfig {
    deliveryConfig: DeliveryConfig;
    masterConfig: MasterConfig;
    noteConfig: NoteConfig;
    catalogueConfig: CatalogueConfig;
    adminConfig: AdminConfig;
    ordersConfig: OrdersConfig;
    monitoringConfig: MonitoringConfig;
    environment: string;
    cloudFixEnabled: boolean;
    baseExecutionDetailsUri: string;
    bucketInvitationEmailConfig: BucketInvitationEmailConfig;
    orderBucketUrl: string;
    buzzOrderAzureReportConfig: BuzzOrderAzureReportConfig;
}

export interface DeliveryConfig {
    apiUrl: string;
    uploadedFilesMaxSelected: number;
}

export interface MasterConfig {
    apiUrl: string;
    drmLicenceServer: string;
    cloudFrontDomain?: string;
}

export interface NoteConfig {
    apiUrl: string;
}

export interface CatalogueConfig {
    apiUrl: string;
}

export interface AdminConfig {
    apiUrl: string;
}

export interface OrdersConfig {
    apiUrl: string;
}

export interface MonitoringConfig {
    apiUrl: string;
}

export interface BucketInvitationEmailConfig {
    subject: string;
    body: string;
}

export interface BuzzOrderAzureReportConfig {
    reportId: string;
}

export const AppConfigContext = React.createContext<AppConfig>({
    environment: "",
    cloudFixEnabled: true,
    baseExecutionDetailsUri: "",
    orderBucketUrl: "",
    deliveryConfig: { apiUrl: "", uploadedFilesMaxSelected: 50 },
    masterConfig: { apiUrl: "", drmLicenceServer: "" },
    noteConfig: { apiUrl: "" },
    catalogueConfig: { apiUrl: "" },
    adminConfig: { apiUrl: "" },
    ordersConfig: { apiUrl: "" },
    monitoringConfig: { apiUrl: "" },
    bucketInvitationEmailConfig: { subject: "", body: "" },
    buzzOrderAzureReportConfig: { reportId: "" }
});
